import { ChevronDown, ChevronUp } from 'lucide-react'

type Props = {
  label:                  string
  itemCount:              number
  urgentCount:            number
  isOpen:                 boolean
  onToggle:               () => void
  selectMode?:            boolean
  allInSectionSelected?:  boolean
  onSelectAllInSection?:  () => void
}

export function LocationSectionHeader({
  label, itemCount, urgentCount, isOpen, onToggle,
  selectMode = false, allInSectionSelected = false, onSelectAllInSection,
}: Props) {
  const lower   = label.toLowerCase()
  const display = lower === 'other' ? 'Other' : `The ${lower}`

  return (
    <div className="flex items-center justify-between py-3 gap-2">
      <button onClick={onToggle} className="flex items-center gap-2 flex-1 min-w-0 text-left">
        <span className="font-serif text-[17px] font-medium text-ink truncate">{display}</span>
        {urgentCount > 0 && (
          <span className="inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-terracotta px-1 text-[10px] font-bold text-cream">
            {urgentCount}
          </span>
        )}
      </button>

      <div className="flex items-center gap-2 flex-shrink-0">
        {selectMode && itemCount > 0 && onSelectAllInSection && (
          <button
            type="button"
            onClick={onSelectAllInSection}
            className={`rounded-full text-[10px] uppercase tracking-[0.12em] font-medium px-2.5 py-1 transition-colors ${
              allInSectionSelected
                ? 'bg-forest text-forest-ink'
                : 'bg-paper border border-border-sand text-ink-muted'
            }`}
          >
            {allInSectionSelected ? 'Selected' : 'Select all'}
          </button>
        )}
        <button onClick={onToggle} className="flex items-center gap-2">
          <span className="text-[12px] text-ink-muted">{itemCount}</span>
          {isOpen
            ? <ChevronUp   className="h-4 w-4 text-ink-muted" strokeWidth={1.5} />
            : <ChevronDown className="h-4 w-4 text-ink-muted" strokeWidth={1.5} />
          }
        </button>
      </div>
    </div>
  )
}
